module.exports = __webpack_public_path__ + "static/NeueHaasUnicaW1G-LightItalic-51135f50e6a15c2d822bad6cc1aeda74.woff2";